<template>
  <div id="app">
      <transition name="fade" mode="out-in">
            <router-view>
            

            </router-view>
      </transition>
  </div>
</template>

<script>
import { eventBus } from './main.js';

export default {
  name: 'app',
  components: {
  },

data: () => ({
    }),
created(){     
//CHECK FOR MOBILE OR DESKTOP 
            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) 
            { 
            // setTimeout(this.preLoadMobile, 1000);
            this.$router.push('/welcome');

            console.log('%c Mobile App Created by Matt McCorkle ' , 'background: black; color: gold');
            
            } else {
            this.$router.push('/');
            console.log('%c Desktop App Created by Matt McCorkle ' , 'background: black; color: gold');}
            },
methods: {
            // preLoadMobile(){
            //       eventBus.$emit('eventBus'); 
            // },
      }
}
</script>

<style>
/** STYLINGS FOR PAGE ON ALL SIZE SCREENS */
    body {
      background-color: black;
      }
    #app {
    font-family: avenir, Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: white;
    margin-top: 10px;
    text-align: center;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
    }
    button:focus {outline:none !important;}
    input:focus {outline:none !important;}

    #evilSlider{
      font-color: white;
    }
    .btn,
    .btn:hover, 
    .btn:focus, 
    .btn:active, 
    .btn:active, 
    .btn:active:focus,
    .btn:active:hover{
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    }
    .btn-success,
    .btn-success:hover, 
    .btn-success:focus, 
    .btn-success:active, 
    .btn-success:active, 
    .btn-success:active:focus,
    .btn-success:active:hover{
    text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    }
    .badge,
    .badge:hover, 
    .badge:focus, 
    .badge:active, 
    .badge:active, 
    .badge:active:focus,
    .badge:active:hover{
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    #Section1TitleText{
    text-shadow: 0px 4px 2px rgba(255, 184, 23, 0.3);  
    }
    #Section2BodyText{
    text-shadow: 0px 4px 2px rgba(255, 184, 23, 0.3);    
    }
    #Section1BodyText{
    text-shadow: 0px 4px 2px rgba(255, 184, 23, 0.3);    
    }
    #MusicNukeBtn{
    text-shadow: 0px 5px 2px rgba(255, 184, 23, 0.3);    
    }
/** HEADINGS AND PARAGRAPH FONTS, MARGIN */
        h1 {
        font-family: roboto-condensed, avenir;
        /*font-weight: 700;*/
        margin-top: 0px;
        } 
        h2 {
        font-family: roboto-condensed, avenir;
          /*margin-top: 0px;*/

        }
        h3 {
        font-family: roboto-condensed, avenir;
          margin-top: 0px;
        }
        h4 {
        font-family: roboto-condensed, avenir;
          margin-top: 0px;
        }
        h5 {
        font-family: roboto-condensed, avenir;
          margin-top: 0px;
        }
        ul {
        font-family: roboto-condensed, avenir;
          padding: 0;
        }
        li {
        font-family: roboto-condensed, avenir;
          display: inline-block;
          margin: 0px;
        }
        a {
          color: #42b983;
        }  
        select option{
          color:#333;
        }
/** STYLINGS FOR VERY SMALL SCREENS < 350px */
      @media (min-width: 0px)  and (max-width: 349px) {
       #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 300px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 26px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 18px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 18px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: 12px;
      margin-bottom: 4px;
      }
      #FutureTitleText{
      font-size: 50px;
      text-align: center;
      margin-top: 50px;
      }
      #FutureFitText{
      font-size: 22px;
      }
      #Section1PullUp{
      margin-top: 20px;
      }
      #Section1TitleText{
      margin-top: -20px;
      margin-bottom: 10px;
      font-size: 16px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 80px;
      margin-bottom: 0px;
      font-size: 16px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 100px;
      margin-bottom: 10px;
      font-size: 16px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 18px;
      margin-bottom: 8px;
      font-size: 16px;
      text-align: center;
      color: white;
      }
      #ambienceBtns{
      width: 120px;
      font-size: 14px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 12px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 20px;
      margin-bottom: 0px;
      }
      #SFXBtnRepeat{
      width: 80px;
      font-size: 12px;
      font-weight: 700;
      padding: 6px 6px;
      margin-left: -8px;
      }
      #SFXBtn{
      width: 110px;
      font-size: 12px;
      margin-top: 10px;
      font-weight: 700;
      padding: 6px 6px;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      margin-left: -10px;
      }
      #SFXRepeatBadge{
      font-size: 9px;
      margin-bottom: 6px;
      margin-left: -10px;
      background-color:orange;
      color: black;
      }
      #audioBadge{
      font-size: 14px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 100%;
      margin-top: 10px;
      margin-bottom: 0px;
      font-size: 14px;
      border-color: #E84B46;
      border-width: 4px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 16px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 0px;
      font-size: 16px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      margin-top: -10px;
      font-size: 16px;
      margin-bottom: 30px;
      }
      #shoutOuts{
      font-size: 14px;
      }
      #shoutOutPullDown{
      margin-top: -50px;
      } 
      #mc_embed_signup{
      margin-bottom: -20px;
      background:#fff; 
      font:14px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:12px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 180px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:12px avenir; 
      padding: 2px 10px;
      margin-top: -2px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }     
      }
/** STYLINGS FOR SMALLER SCREENS < 600px   */
      @media (min-width: 350px) and (max-width: 600px) {
      #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 400px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 30px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 18px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 20px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: 0px;
      }
      #FutureTitleText{
      font-size: 50px;
      text-align: center;
      margin-top: 50px;
      }
      #FutureFitText{
      font-size: 22px;
      }
      #Section1PullUp{
      margin-top: 20px;
      }
      #Section1TitleText{
      margin-top: -20px;
      margin-bottom: 10px;
      font-size: 20px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 80px;
      margin-bottom: 0px;
      font-size: 20px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 100px;
      margin-bottom: 10px;
      font-size: 22px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 18px;
      margin-bottom: 8px;
      font-size: 20px;
      text-align: center;
      color: white;
      }
      #ambienceBtns{
      width: 140px;
      font-size: 16px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 14px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 20px;
      margin-bottom: 0px;
      }
      #SFXBtnRepeat{
      width: 90px;
      font-size: 14px;
      font-weight: 700;
      padding: 6px 6px;
      margin-left: -8px;
      }
      #SFXBtn{
      width: 40%;
      font-size: 14px;
      margin-top: 10px;
      margin-left: 10px;
      font-weight: 700;
      padding: 6px 6px;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      }
      #SFXRepeatBadge{
      font-size: 11px;
      margin-left: -12px;
      margin-bottom: 6px;
      background-color:orange;
      color: black;
      }
      #audioBadge{
      font-size: 16px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 310px;
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 20px;
      border-color: #E84B46;
      border-width: 4px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      padding: 6px 6px;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 18px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 0px;
      font-size: 16px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      margin-top: 20px;
      font-size: 20px;
      }
      #shoutOuts{
      font-size: 18px;
      }
      #shoutOutPullDown{
      margin-top: -20px;
      }
      #mc_embed_signup{
      background:#fff; 
      font:14px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:14px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 200px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:14px avenir; 
      padding: 2px 10px;
      margin-top: -2px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }  
      }
/** STYLINGS FOR MEDIUM SCREENS < 768px   */
      @media (min-width: 600px) and (max-width: 768px) {
      #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 600px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 30px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 18px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 20px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: 0px;
      }
      #FutureTitleText{
      font-size: 50px;
      text-align: center;
      margin-top: 50px;
      }
      #FutureFitText{
      font-size: 22px;
      }
      #Section1PullUp{
      margin-top: 20px;
      }
      #Section1TitleText{
      margin-top: -20px;
      margin-bottom: 10px;
      font-size: 22px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 80px;
      margin-bottom: 0px;
      font-size: 22px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 100px;
      margin-bottom: 10px;
      font-size: 30px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 18px;
      margin-bottom: 8px;
      font-size: 22px;
      text-align: center;
      color: white;
      }
      #ambienceBtns{
      width: 270px;
      font-size: 20px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 14px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 10px;
      margin-bottom: 0px;
      }
      #SFXBtnRepeat{
      width: 160px;
      font-size: 18px;
      font-weight: 700;
      padding: 6px 6px;
      /*margin-top: 10px;
      margin-left: 10px;*/
      }
      #SFXBtn{
      width: 200px;
      font-size: 18px;
      margin-top: 10px;
      margin-left: 10px;
      font-weight: 700;
      padding: 6px 6px;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      }
      #SFXRepeatBadge{
      font-size: 16px;
      margin-bottom: 6px;
      background-color:orange;
      color: black;
      }
      #audioBadge{
      font-size: 20px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 560px;
      margin-top: 10px;
      margin-bottom: 0px;
      font-size: 20px;
      border-color: #E84B46;
      border-width: 4px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 18px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 20px;
      font-size: 20px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      margin-top: 30px;
      font-size: 30px;
      }
      #shoutOuts{
      font-size: 25px;
      }
      #shoutOutPullDown{
      margin-top: 40px;
      }    
      #mc_embed_signup{
      background:#fff; 
      font:20px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:20px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 300px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:20px avenir; 
      padding: 2px 10px;
      margin-top: -4px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }  
      }
/** STYLINGS FOR TABLET SCREENS  < 1025px   */
      @media (min-width: 769px) and (max-width: 1024px){
      #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 800px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 32px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 22px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 22px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: 10px;
      margin-bottom: 0px;
      }
      /*#FutureTitleText{
      font-size: 50px;
      text-align: center;
      margin-top: 50px;
      }
      #FutureFitText{
      font-size: 22px;
      }*/
      #Section1PullUp{
      margin-top: -40px;
      }
      #Section1TitleText{
      margin-top: 40px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 14px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 40px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 30px;
      margin-bottom: 10px;
      font-size: 32px;
      text-align: center;
      color: white;  
      }
      #ambienceBtns{
      width: 326px;
      font-size: 28px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 18px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 0px;
      margin-bottom: 10px;
      }
      #SFXBtnRepeat{
      width: 180px;
      font-size: 24px;
      font-weight: 700;
      /*margin-top: 10px;
      margin-left: 10px;*/
      }
      #SFXBtn{
      width: 235px;
      font-size: 24px;
      margin-top: 10px;
      margin-left: 10px;
      font-weight: 700;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      }
      #SFXRepeatBadge{
      font-size: 20px;
      margin-bottom: 6px;
      background-color:orange;
      color: black;
      }
      #playbtnSidebySide{
      font-size: 25px;
      border-radius: 8px;
      padding: 0px 6px;
      vertical-align: middle;
      height: 45px;
      width: 45px;
      margin-top: -20px;
      border-width: 4px;
      background-color:transparent;
      }
      #audioBadge{
      font-size: 22px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 712px;
      margin-top: 30px;
      margin-bottom: 10px;
      font-size: 30px;
      border-color: #E84B46;
      border-width: 4px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 22px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 20px;
      font-size: 22px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      margin-top: 30px;
      font-size: 30px;
      }
      #shoutOuts{
      font-size: 25px;
      }
      #shoutOutPullDown{
      margin-top: 40px;
      }
      #mc_embed_signup{
      background:#fff; 
      font:20px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:20px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 350px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:20px avenir; 
      padding: 2px 10px;
      margin-top: -4px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }     
      }
/** STYLINGS FOR BIG TABLET SCREENS  > 769px   */
      @media (min-width: 1024px) and (max-width: 1399px){
      #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 900px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 34px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 24px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 24px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: 10px;
      margin-bottom: 0px;
      }
      /*#FutureTitleText{
      font-size: 50px;
      text-align: center;
      margin-top: 50px;
      }
      #FutureFitText{
      font-size: 22px;
      }*/
      #Section1PullUp{
      margin-top: -50px;
      }
      #Section1TitleText{
      margin-top: 40px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 14px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 40px;
      margin-bottom: 0px;
      font-size: 34px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 30px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;  
      }
      #ambienceBtns{
      width: 385px;
      font-size: 28px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 18px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 20px;
      margin-bottom: 20px;
      }
      #SFXBtnRepeat{
      width: 226px;
      font-size: 24px;
      font-weight: 700;
      padding: 6px 6px;
      /*margin-top: 10px;
      margin-left: 10px;*/
      }
      #SFXBtn{
      width: 200px;
      font-size: 24px;
      margin-top: 10px;
      margin-left: 10px;
      font-weight: 700;
      padding: 6px 6px;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      }
      #SFXRepeatBadge{
      font-size: 20px;
      margin-bottom: 6px;
      background-color:orange;
      color: black;
      }
      #playbtnSidebySide{
      font-size: 25px;
      border-radius: 8px;
      padding: 0px 6px;
      vertical-align: middle;
      height: 45px;
      width: 45px;
      margin-top: -20px;
      border-width: 4px;
      background-color:transparent;
      }
      #audioBadge{
      font-size: 22px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 826px;
      margin-top: 30px;
      margin-bottom: 10px;
      font-size: 30px;
      border-color: #E84B46;
      border-width: 6px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 24px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 20px;
      font-size: 24px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      margin-top: 30px;
      font-size: 30px;
      }
      #shoutOuts{
      font-size: 25px;
      }
      #shoutOutPullDown{
      margin-top: 40px;
      }  
      #mc_embed_signup{
      background:#fff; 
      font:22px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:22px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 350px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:22px avenir; 
      padding: 2px 10px;
      margin-top: -4px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }        
    }
/** STYLINGS FOR DESKTOP SCREENS > 1600px  */
      @media (min-width: 1400px) {
      #noPadding{
      padding-right: 0px;
      padding-left: 0px;
      max-width: 1000px;
      }
      #welcomeInfoText{
      margin-top: 50px;
      font-size: 40px;
      color: red;  
      font-weight: 700;
      }
      #welcomeMobileText{
      color: white;
      font-size: 26px;
      }
      #playButton{
      margin-top: 20px;
      font-size: 30px;
      border-width: 1px;
      }
      #svgTitle{
      margin-top: -80px;
      margin-bottom: 0px;
      }
      #Section1PullUp{
      margin-top: 0px;
      }
      #Section1TitleText{
      margin-top: -20px;
      margin-bottom: 10px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section1BodyText{
      margin-top: 14px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;
      }
      #Section2TitleText{
      margin-top: 30px;
      margin-bottom: 0px;
      font-size: 40px;
      text-align: center;
      color: white;
      }
      #Section2BodyText{
      margin-top: 30px;
      margin-bottom: 0px;
      font-size: 32px;
      text-align: center;
      color: white;  
      }
      #ambienceBtns{
      width: 390px;
      font-size: 28px;
      font-weight: 700;
      }
      #ambienceBadges{
      font-size: 18px;
      background-color:pink;
      color: black; 
      }
      #Evilizor{
      margin-top: 20px;
      margin-bottom: 20px;
      }
      #SFXBtnRepeat{
      width: 220px;
      font-size: 24px;
      font-weight: 700;
      /*margin-top: 10px;
      margin-left: 10px;*/
      }
      #SFXBtn{
      width: 215px;
      font-size: 24px;
      margin-top: 10px;
      margin-left: 10px;
      font-weight: 700;
      }
      #SFXRepearSlider{
      margin-top: 4px;
      }
      #SFXRepeatBadge{
      font-size: 20px;
      margin-bottom: 6px;
      background-color:orange;
      color: black;
      }
      #playbtnSidebySide{
      font-size: 25px;
      border-radius: 8px;
      padding: 0px 6px;
      vertical-align: middle;
      height: 45px;
      width: 45px;
      margin-top: -20px;
      border-width: 4px;
      background-color:transparent;
      }
      #audioBadge{
      font-size: 20px;
      background-color:white;
      color: black;  
      }
      #MusicNukeBtn{
      width: 890px;
      margin-top: 30px;
      margin-bottom: 10px;
      font-size: 30px;
      border-color: #E84B46;
      border-width: 6px;
      background-color: transparent;
      color: white;
      font-weight: 700;
      }
      #helpBtn{
      margin-top: 40px;
      font-size: 26px;
      margin-bottom: 20px;
      }
      #helpBtnHome{
      margin-top: 0px;
      font-size: 26px;      
      }
      #helpTxt{

      }
      #mattMcCorkle{
      color: red;
      margin-top: 30px;
      font-size: 30px;
      }
      #shoutOuts{
      font-size: 25px;
      }
      #shoutOutPullDown{
      margin-top: 40px;
      }  

      #mc_embed_signup{
      background:#fff; 
      font:22px avenir; 
      width:100%;
      border-color: white;
      background-color: black;
      }
      #mce-EMAIL{
      font:22px avenir; 
      padding: 4px 10px;
      margin-top: 0px;  
      font-weight: 800;
      width: 350px;
      border-width: 4px;
      border-radius: 10px;
      background-color: black;
      }
      #mc-embedded-subscribe{
      font:22px avenir; 
      padding: 2px 10px;
      margin-top: -4px;
      font-weight: 800;
      border-width: 3px;
      border-radius: 10px;
      background-color: black;
      border-color: white;
      }      
    }
/** BOOTSTRAP BUTTON COLORS    */
      .btn-danger {
          color: white;
      } 
      /*INFO*/
      .btn-info {
      color: #07CBFF;
      background-color: #1ED7FF;
      border-color: #1ED7FF; 
      }

      .btn-info,
      .btn-info:hover, 
      .btn-info:focus, 
      .btn-info:active, 
      .btn-info.active, 
      .btn-info:active:focus
      .open>.dropdown-toggle.btn-info {
      color: white;
      background-color: #1ED7FF;
      border-color: #1ED7FF; 
      }

      /*SUCCESS*/
      .btn-success {
      color: #fff;
      background-color: #5CE826;
      border-color: #5CE826; 
      }
      .btn-success,
      .btn-success:hover, 
      .btn-success:focus, 
      .btn-success:active, 
      .btn-success.active, 
      .btn-success:active:focus
      .open>.dropdown-toggle.btn-success {
      color: black;
      background-color: #5CE826;
      border-color: #5CE826; 
      }

      /*WARNING*/
      .btn-warning {
      color: #fff;
      background-color: #FFB817;
      border-color: #FFB817; 
      }
      .btn-warning,
      .btn-warning:hover, 
      .btn-warning:focus, 
      .btn-warning:active, 
      .btn-warning:active:focus
      .btn-warning.active, 
      .open>.dropdown-toggle.btn-warning {
      color: white;
      background-color: #FFB817;
      border-color: #FFB817; 
      }

      /*DANGER*/
      .btn-danger {
      color: #fff;
      background-color: #E84B46;
      border-color: #E84B46; 
      }
      .btn-danger,
      .btn-danger:hover, 
      .btn-danger:focus, 
      .btn-danger:active, 
      .btn-danger.active,
      .btn-danger:active:focus 
      .open>.dropdown-toggle.btn-danger {
      color: white;
      background-color: #E84B46;
      border-color: #E84B46; 
      }

      /*PRIMARY*/
      .btn-primary {
      color: #fff;
      background-color: #9776FF;
      border-color: #9776FF; 
      }
      .btn-primary,
      .btn-primary:hover, 
      .btn-primary:focus, 
      .btn-primary:active, 
      .btn-primary.active, 
      .btn-primary:active:focus
      .open>.dropdown-toggle.btn-primary {
      color: white;
      background-color: #9776FF;
      border-color: #9776FF; 
      }   

      /*ACCENT*/
      .btn-accent {
      color: #fff;
      background-color: #6B8CFF;
      border-color: #6B8CFF; 
      }
      .btn-accent,
      .btn-accent:hover, 
      .btn-accent:focus, 
      .btn-accent:active, 
      .btn-accent.active, 
      .btn-accent:active:focus
      .open>.dropdown-toggle.btn-accent {
      color: white;
      background-color: #6B8CFF;
      border-color: #6B8CFF; 
      }   

      /*BLACK AND WHITE*/
      .btn-blackwhite {
      color: white;
      background-color: black;
      border-color: white; 
      }
      .btn-blackwhite,
      .btn-blackwhite:hover, 
      .btn-blackwhite:focus, 
      .btn-blackwhite:active, 
      .btn-blackwhite.active, 
      .btn-blackwhite:active:focus
      .open>.dropdown-toggle.btn-blackwhite {
      color: white;
      background-color: black;
      border-color: white; 
      }   

      /*BLACK AND WHITE NEGATIVE*/
      .btn-blackwhiteneg {
      color: black;
      background-color: #FFB817;
      border-color: #FFB817; 
      }
      .btn-blackwhiteneg,
      .btn-blackwhiteneg:hover, 
      .btn-blackwhiteneg:focus, 
      .btn-blackwhiteneg:active, 
      .btn-blackwhiteneg.active, 
      .btn-blackwhiteneg:active:focus
      .open>.dropdown-toggle.btn-blackwhiteneg {
      color: black;
      background-color: #FFB817;
      border-color: #FFB817; 
      }   

      /*TRANSPARENT*/
      .btn-transparent {
      color: white;
      background-color: transparent;
      border-color: white;
      border-width: 1px; 
      }
      .btn-transparent,
      .btn-transparent:hover, 
      .btn-transparent:focus, 
      .btn-transparent:active, 
      .btn-transparent.active, 
      .btn-transparent:active:focus
      .open>.dropdown-toggle.btn-transparent {
      color: white;
      background-color: transparent;
      border-color: white; 
      border-width: 1px;
      } 
/** STYLINGS FOR TRANSITIONS */
        .animated.rubberBand {
          -webkit-animation-duration: 1.5s;
             -moz-animation-duration: 1.5s;
              -ms-animation-duration: 1.5s;
               -o-animation-duration: 1.5s;
                  animation-duration: 1.5s;
        }
        .animated.rollOut {
          -webkit-animation-duration: .75s;
             -moz-animation-duration: .75s;
              -ms-animation-duration: .75s;
               -o-animation-duration: .75s;
                  animation-duration: .75s;
        }
        .animated.pulse {
          -webkit-animation-duration: .3s;
             -moz-animation-duration: .3s;
              -ms-animation-duration: .3s;
               -o-animation-duration: .3s;
                  animation-duration: .3s;
        }
        .animated.hinge {
          -webkit-animation-duration: 1.75s;
             -moz-animation-duration: 1.75s;
              -ms-animation-duration: 1.75s;
               -o-animation-duration: 1.75s;
                  animation-duration: 1.75s;
        }
        .animated.fadeOut {
          -webkit-animation-duration: .2s;
             -moz-animation-duration: .2s;
              -ms-animation-duration: .2s;
               -o-animation-duration: .2s;
                  animation-duration: .2s;
        }
        .animated.fadeIn {
          -webkit-animation-duration: .2s;
             -moz-animation-duration: .2s;
              -ms-animation-duration: .2s;
               -o-animation-duration: .2s;
                  animation-duration: .2s;
        }
        

          .fade-enter {
            opacity: 0;
          }

          .fade-enter-active {
            transition: opacity .5s; 
          }

          .fade-leave {
          }

          .fade-leave-active {
            transition: opacity .5s; 
            opacity: 0;
          }
/** COUNTER SPIN FONT AWESOME */
    .fa-counter-spin {
      -webkit-animation: spin-counter .2s infinite linear;
      -moz-animation: spin-counter .2s infinite linear;
      -o-animation: spin-counter .2s infinite linear;
      animation: spin-counter .2s infinite linear;
    }
    @-moz-keyframes spin-counter {
      0% {
        -moz-transform: rotate(359deg);
      }
      100% {
        -moz-transform: rotate(0deg);
      }
    }
    @-webkit-keyframes spin-counter {
      0% {
        -webkit-transform: rotate(359deg);
      }
      100% {
        -webkit-transform: rotate(0deg);
      }
    }
    @-o-keyframes spin-counter {
      0% {
        -o-transform: rotate(359deg);
      }
      100% {
        -o-transform: rotate(0deg);
      }
    }
    @-ms-keyframes spin-counter {
      0% {
        -ms-transform: rotate(359deg);
      }
      100% {
        -ms-transform: rotate(0deg);
      }
    }
    @keyframes spin-counter {
      0% {
        transform: rotate(359deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
/* RANGER STYLINGS            */
    /*.vranger {
      margin-top: 50px;
       transform: rotate(270deg);
      -moz-transform: rotate(270deg); 
    }*/
    /*input[type="range"] {
      -webkit-appearance: none;
      background-color: white;
      height: 4px;
      width: 125px;
      margin: auto;
    }*/
    /*input[type="range"]:hover ~ #rangevalue,
    input[type="range"]:active ~ #rangevalue {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
      filter: alpha(opacity=100);
      opacity: 1;
      top: -75px;
    }
    input[type="range"]:focus {
      outline: none;
    }*/
    /*DANGER RANGER*/
    @media (min-width: 1400px) {
      input[class="dangerRanger"] {
      -webkit-appearance: none;
      background-color: #E84B46;
      height: 8px;
      width: 200px;
      margin: auto;
      border-radius: 10px;
      }
      input[class="dangerRanger"]::-ms-track{
      background-color: #E84B46;
      height: 8px;
      width: 200px;
      margin: auto;
      border-radius: 10px;
      }
      }
      @media (max-width: 1399px) {
      input[class="dangerRanger"] {
      -webkit-appearance: none;
      background-color: #E84B46;
      height: 8px;
      width: 125px;
      margin: auto;
      border-radius: 10px;
       }
       input[class="dangerRanger"]::-ms-track{
      background-color: #E84B46;
      height: 8px;
      width: 125px;
      margin: auto;
      border-radius: 10px;
      }
      }
      @media (max-width: 500px) {
     input[class="dangerRanger"] {
      -webkit-appearance: none;
      background-color: #E84B46;
      height: 8px;
      width: 100px;
      margin: auto;
      border-radius: 10px;
       }
       input[class="dangerRanger"]::-ms-track{
      background-color: #E84B46;
      height: 4px;
      width: 100px;
      margin: auto;
      border-radius: 10px;
      }
      }

    input[class="dangerRanger"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(50%, #abd3ee), color-stop(100%, red), color-stop(100%, #d5ebfb));
    }

    
    input[class="dangerRanger"]::-moz-range-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(50%, #abd3ee), color-stop(100%, red), color-stop(100%, #d5ebfb));
    }

      
      input[class="dangerRanger"]::-ms-thumb{
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 30px;
      height: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(50%, #abd3ee), color-stop(100%, red), color-stop(100%, #d5ebfb));
      }  
      input[class=dangerRanger]::-ms-fill-upper {
      background:  blue;
      }
      input[class=dangerRanger]::-ms-fill-lower {
      background:  white
      }

    input[class="dangerRanger2"] {
      -webkit-appearance: none;
      background-color: red;
      height: 8px;
      width: 200px;
      margin: auto;
      border-radius: 10px;
    }

    input[class="dangerRanger2"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(100%, red), color-stop(100%, red), color-stop(100%, #d5ebfb));
    }

    input[class="dangerRanger2"]::-moz-range-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(100%, red), color-stop(100%, red), color-stop(100%, #d5ebfb));
    }

    /*WARNING RANGER*/
      @media (min-width: 1400px) {
      input[class="warningRanger"] {
      -webkit-appearance: none;
      background-color: #FFB817;
      height: 8px;
      width: 160px;
      margin: auto;
      border-radius: 10px;
      }
      }
      @media (max-width: 1399px) {
      input[class="warningRanger"] {
      -webkit-appearance: none;
      background-color: #FFB817;
      height: 8px;
      width: 150px;
      margin: auto;
      border-radius: 10px;
      }
      }
      @media (max-width: 800px) {
      input[class="warningRanger"] {
      -webkit-appearance: none;
      background-color: #FFB817;
      height: 8px;
      width: 85px;
      margin: auto;
      border-radius: 10px;
      }
      }
       @media (max-width: 500px) {
      input[class="warningRanger"] {
      -webkit-appearance: none;
      background-color: #FFB817;
      height: 8px;
      width: 80px;
      margin: auto;
      border-radius: 10px;
      }
      }
     input[class="warningRanger"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #FFB817), color-stop(50%, #abd3ee), color-stop(100%, #FFB817), color-stop(100%, #d5ebfb));
    }

    input[class="warningRanger"]::-moz-range-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 35px;
      height: 35px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #FFB817), color-stop(50%, #abd3ee), color-stop(100%, #FFB817), color-stop(100%, #d5ebfb));
    }
    /*PRIMARY RANGER*/
    input[class="primaryRanger"] {
      -webkit-appearance: none;
      background-color: #9776FF;
      height: 4px;
      width: 80px;
      margin: auto;
    }

     input[class="primaryRanger"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 30px;
      height: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #9776FF), color-stop(50%, #abd3ee), color-stop(100%, #9776FF), color-stop(100%, #d5ebfb));
    }
    /*SUCCESS RANGER*/
    input[class="successRanger"] {
      -webkit-appearance: none;
      background-color: #5CE826;
      height: 4px;
      width: 80px;
      margin: auto;
    }

     input[class="successRanger"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 30px;
      height: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #5CE826), color-stop(50%, #abd3ee), color-stop(100%, #5CE826), color-stop(100%, #d5ebfb));
    }
    /*INFO RANGER*/
    input[class="infoRanger"] {
      -webkit-appearance: none;
      background-color: #1ED7FF;
      height: 4px;
      width: 80px;
      margin: auto;
    }

     input[class="infoRanger"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      position: relative;
      top: 0px;
      z-index: 1;
      width: 30px;
      height: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
      box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      border-radius: 40px;
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, red), color-stop(%, #abd3ee), color-stop(100%, #1ED7FF), color-stop(100%, #d5ebfb));
    }
    
    /*background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ebf1f6), color-stop(50%, #abd3ee), color-stop(51%, #89c3eb), color-stop(100%, #d5ebfb)); */
</style>

<style lang="scss">
/* STYLINGS FOR VERY SMALL SCREENS < 350px */
      @media (max-width: 349px) {
    $colors: #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 80;
      $dash-gap: 10;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 8s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 8;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }



      #discoTitle {
        background: black;
        /*background-size: .2em 100%;*/
        font: 12em/0 avenir, Arial;
        text-transform: uppercase;
        font-weight: 800;
        margin: 0;
        padding-right: 0px;
        padding-left: 0px;
        margin-top: -20px;
        }

      #svgTitle {
        width: 100%;
        height: 100%;
      }
      }
/* STYLINGS FOR SMALLER SCREENS < 600px   */ 
      @media (min-width: 350px) and (max-width: 600px) {
      $colors: #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 80;
      $dash-gap: 10;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 6s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 6;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }



      #discoTitle {
        background: black;
        /*background-size: .2em 100%;*/
        font: 12em/0 avenir, Arial;
        text-transform: uppercase;
        font-weight: 800;
        padding-right: 0px;
        padding-left: 0px;
        margin-bottom: 0px;
        }

      #svgTitle {
        width: 100%;
        height: 100%;
      }
      }
/* STYLINGS FOR MEDIUM SCREENS < 768px   */ 
      @media (min-width: 600px) and (max-width: 768px) {
      $colors:  #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 60;
      $dash-gap: 8;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 5s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 6;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }



      #discoTitle {
        background: black;
        /*background-size: .2em 100%;*/
        font: 12em/0 avenir, Arial;
        text-transform: uppercase;
        font-weight: 800;
        padding-right: 0px;
        padding-left: 0px;
        margin-bottom: 0px;
        }

      #svgTitle {
        width: 100%;
        height: 100%;
      }
      }
/* STYLINGS FOR TABLET SCREENS  < 1025px   */
      @media (min-width: 769px) and (max-width: 1024px){
      
     $colors: #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 40;
      $dash-gap: 2;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 5s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 7;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

        #discoTitle {
          background: black;
          /*background-size: .2em 100%;*/
          font: 12em/0 avenir, Arial;
          text-transform: uppercase;
          font-weight: 800;
          margin: 0;
        }
        .br{
          display: none;
        }
        #svgTitle {
        width: 100%;
        height: 100%;
      }
      }
/* STYLINGS FOR BIG TABLET SCREENS  > 1025px   */
      @media (min-width: 1024px) and (max-width: 1399px){
      
      $colors: #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 40;
      $dash-gap: 2;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 5s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 5;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

        #discoTitle {
          background: black;
          /*background-size: .2em 100%;*/
          font: 11em/0 avenir, Arial;
          text-transform: uppercase;
          font-weight: 800;
          margin: 0px;
        }
        .br{
          display: none;
        }
        #svgTitle {
        width: 100%;
        height: 100%;
        }
    } 
/* STYLINGS FOR DESKTOP SCREENS > 1600px  */
      @media (min-width: 1400px) {
      
      $colors: #FFB817, #E84B46, black;
      $max: length($colors);
      $dash: 40;
      $dash-gap: 2;
      $dash-space: $dash * ($max - 1) + $dash-gap * $max;
      $time: 5s;
      $time-step: $time/$max;

      /* Main styles */
      @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);

      .text {
        fill: none;
        stroke-width: 4;
        stroke-linejoin: round;
        stroke-dasharray: $dash $dash-space;
        stroke-dashoffset: 0;
        -webkit-animation: stroke $time infinite linear;
        animation: stroke $time infinite linear;
        
        @for $item from 1 through $max {
          &:nth-child(#{$max}n + #{$item}) {
            $color: nth($colors, $item);
            stroke: $color;
            -webkit-animation-delay: -($time-step * $item);
            animation-delay: -($time-step * $item);
          }
        }
      }

      @-webkit-keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

      @keyframes stroke {
        100% {
          stroke-dashoffset: -($dash + $dash-gap) * $max;
        }
      }

        #discoTitle {
          background: black;
          /*background-size: .2em 100%;*/
          font: 10em/0 avenir, Arial;
          text-transform: uppercase;
          font-weight: 800;
          margin-top: 100px;
        }
        .br{
          display: none;
        }
        #svgTitle {
        width: 100%;
        height: 100%;
        } 
}
</style>



// WEBPACK FOOTER //
// App.vue?6652bd3e